"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HashtagIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HashtagIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M11.7353516,19.5009766 L12.5732422,15.34375 L9.52246094,15.34375 L8.67382812,19.5009766 L6.61132812,19.5009766 L7.44921875,15.34375 L5,15.34375 L5.38671875,13.2597656 L7.86816406,13.2597656 L8.51269531,10.0478516 L5.97753906,10.0478516 L6.375,7.98535156 L8.92089844,7.98535156 L9.74804688,4 L11.7998047,4 L11.0048828,7.98535156 L14.0449219,7.98535156 L14.8720703,4 L16.9453125,4 L16.1289062,7.98535156 L18.7177734,7.98535156 L18.3310547,10.0478516 L15.7207031,10.0478516 L15.0546875,13.2597656 L17.71875,13.2597656 L17.3320312,15.34375 L14.6464844,15.34375 L13.8085938,19.5009766 L11.7353516,19.5009766 Z M9.80175781,13.4101562 L13.0458984,13.4101562 L13.7763672,9.91894531 L10.5107422,9.91894531 L9.80175781,13.4101562 Z" })
  );
}